<template>
  <div>
    <div v-if="notFound" class="mt-5 ml-5">Référent introuvable</div>
  </div>
</template>

<script>
import { fetchHil2 } from "../utils";

export default {
  name: "CompanyReferer",
  data() {
    return {
      notFound: false
    };
  },
  async mounted() {
    const company = await fetchHil2(
      "get",
      `/prospects/tech/${this.$route.params.shortid}/${
        this.$route.params.techname
      }`
    );

    if (company.statusCode === 404) {
      this.notFound = true;
      this.$router.push({ name: "signup" });
      return;
    }

    window.localStorage.setItem("companyReferer", company.id);
    window.localStorage.setItem("companyRefererName", company.name);

    this.$router.push({ name: "signup" });
  }
};
</script>

<style scoped></style>
